import { AzureIndexesContext } from "@/context/AzureIndexesContext";
import React from "react";

export default function useAzureIndexes() {
  return React.useContext(AzureIndexesContext);
}
